module.exports = __webpack_public_path__ + "static/media/en-cancel-service_1.c7e4f2f1.png";